/** Age range options for passenger registration. */
export const AGE_RANGE_OPTIONS = [
  { value: 'adult', label: 'Adult (18+)' },
  { value: 'child_4_12', label: 'Child (4–12 years)' },
  { value: 'child_0_3', label: 'Child (3 years and under)' },
];

export const AGE_RANGE_LABELS = Object.fromEntries(AGE_RANGE_OPTIONS.map((o) => [o.value, o.label]));

/** Seats used: every person counts, including children 3 and under. */
export function partySeatCount(partyTotal) {
  return Math.max(1, parseInt(partyTotal, 10) || 1);
}
